module.exports = __webpack_public_path__ + "media/header_kdykoliv.64198920.mp4";